import { render, staticRenderFns } from "./stripe-person-form-page.vue?vue&type=template&id=30e02c56&"
import script from "./stripe-person-form-page.vue?vue&type=script&lang=js&"
export * from "./stripe-person-form-page.vue?vue&type=script&lang=js&"
import style0 from "./stripe-person-form-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports